import React, { Component } from "react";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { ListItemText } from "@material-ui/core/";
import ApproachCheckbox from "../ScreenComponents/ApproachCheckbox";

const useStyles = (theme) => ({
  headerClass: {
    color: "white",
    backgroundColor: theme.palette.primary.dark,
    padding: "15px",
    fontSize: "1em",
  },
  formContainer: {
    position: "relative",
    height: "auto",
    padding: "2rem",
  },
  gridcontainer: {
    alignItems: "center",
    justify: "center",
  },
  choiceClass: {
    color: "white",
    backgroundColor: theme.palette.primary.light,
  },
  dialog: {
    backgroundColor: theme.palette.primary.dark,
  },
  formControl: {
    margin: theme.spacing(0),
    minWidth: 150,
  },
});

export class ApproachSelect extends Component {
  state = {
    bool: false,
  };

  continue = (e) => {
    e.preventDefault();
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  getDescription = (curDict) => {
    return curDict["Resources"];
  };

  setApproach = (val, approach) => {
    this.setState({ bool: val.target.checked });
    this.props.currentContext.setApproach(val.target.checked, approach);
  };

  render() {
    const { classes } = this.props;
    const approachList = Object.keys(
      this.props.currentContext.approachDescriptions
    );
    console.log(approachList[0]);
    return (
      <MuiThemeProvider>
        <Grid
          container
          className={classes.formContainer}
          direction="column"
          spacing={2}
        >
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="center"
            spacing={3}
          >
            {approachList.map((elem) => (
              <Grid item xs={5} key={approachList.indexOf(elem)}>
                <ApproachCheckbox
                  checkedVal={this.props.currentContext.approachChoice[elem]}
                  nameVal={elem}
                  approachVal={elem}
                  handler={this.setApproach}
                />
                <ListItemText
                  secondary={this.getDescription(
                    this.props.currentContext.approachDescriptions[elem]
                  )}
                />
              </Grid>
            ))}
          </Grid>
          <Grid item container direction="row" spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="secondary"
                variant="contained"
                onClick={this.back}
              >
                Back
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={this.continue}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(ApproachSelect);

/*
  render() {
    const { classes } = this.props;
    const { values, handleChange } = this.props;
    return (
      <MuiThemeProvider>
        <Grid
          container
          className={classes.formContainer}
          direction="column"
          spacing={2}
        >
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            justify="center"
            spacing={3}
          >
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Advisory Down-Select'
                  ]
                }
                nameVal="Advisory Down-Select"
                approachVal="Advisory Down-Select"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Advisory Down-Select'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice['Discovery']
                }
                approachVal="Discovery"
                nameVal="Discovery"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions['Discovery']
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Evaluate Innovation'
                  ]
                }
                approachVal="Evaluate Innovation"
                nameVal="Evaluate Innovation"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Evaluate Innovation'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Group Oral Debriefings'
                  ]
                }
                approachVal="Group Oral Debriefings"
                nameVal="Group Oral Debriefings"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Group Oral Debriefings'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Mission-Focused Evaluation Criteria'
                  ]
                }
                approachVal="Mission-Focused Evaluation Criteria"
                nameVal="Mission-Focused Evaluation Criteria"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Mission-Focused Evaluation Criteria'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Experience via Questions'
                  ]
                }
                approachVal="Experience via Questions"
                nameVal="Experience via Questions"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Experience via Questions'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice['Video Proposals']
                }
                approachVal="Video Proposals"
                nameVal="Video Proposals"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Video Proposals'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Skip Adjectival Ratings'
                  ]
                }
                approachVal="Skip Adjectival Ratings"
                nameVal="Skip Adjectival Ratings"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Skip Adjectival Ratings'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Iterative-Based Competition'
                  ]
                }
                approachVal="Iterative-Based Competition"
                nameVal="Iterative-Based Competition"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Iterative-Based Competition'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'AStage-Based Competition'
                  ]
                }
                approachVal="Stage-Based Competition"
                nameVal="Stage-Based Competition"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Stage-Based Competition'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Incentive Prize-Based Competition'
                  ]
                }
                approachVal="Incentive Prize-Based Competition"
                nameVal="Incentive Prize-Based Competition"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Incentive Prize-Based Competition'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice[
                    'Challenge-Based Competition'
                  ]
                }
                approachVal="Challenge-Based Competition"
                nameVal="Challenge-Based Competition"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Challenge-Based Competition'
                  ]
                }
              />
            </Grid>
            <Grid item xs={5}>
              <ApproachCheckbox
                checkedVal={
                  this.props.currentContext.approachChoice['Milestone-Based']
                }
                approachVal="Milestone-Based"
                nameVal="Milestone-Based"
                handler={this.setApproach}
              />
              <ListItemText
                secondary={
                  this.props.currentContext.approachDescriptions[
                    'Milestone-Based'
                  ]
                }
              />
            </Grid>
          </Grid>
          <Grid item container direction="row" spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="secondary"
                variant="contained"
                onClick={this.back}
              >
                Back
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={this.continue}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(ApproachSelect);
*/
